import { gql } from "@apollo/client/core";

export default gql`
  query OgReportRequestModal {

      getProjectsAdmin {
          _id
          name
      }
      
  }
`;
